import { useRouter } from "next/router"
import { useEffect } from "react"

import { prepareCheckoutReplayForUrl, syncCheckoutReplayForRoute } from "../utils/amplitude"

const PagesRouterAmplitudeSync = () => {
  const router = useRouter()

  useEffect(() => {
    if (typeof window === "undefined") return

    const handleRouteChangeStart = (url: string) => {
      void prepareCheckoutReplayForUrl(url)
    }

    router.events.on("routeChangeStart", handleRouteChangeStart)
    router.events.on("hashChangeStart", handleRouteChangeStart)

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart)
      router.events.off("hashChangeStart", handleRouteChangeStart)
    }
  }, [router.events])

  useEffect(() => {
    void syncCheckoutReplayForRoute(router.pathname, router.asPath)
  }, [router.asPath, router.pathname])

  return null
}

export default PagesRouterAmplitudeSync
